export default __webpack_public_path__ + "static/media/orange.839534d3.jpg";